import axios from 'axios';

var axiosGeoIpApi = axios.create({
    baseURL: "https://api.ipgeolocation.io/ipgeo?apiKey=990866e1fcbe4ab296f4c79fcc773c46",    
  //baseURL: "https://ipinfo.io"
});
//axiosGeoIpApi.defaults.headers.common['Authorization'] = 'Bearer ' + '408cecb3020221';

export default axiosGeoIpApi;
